var map = {
	"./El;ectric Purple.png": 1720,
	"./Neon Orange.png": 8779,
	"./Neon Pink.png": 7164,
	"./Practice Ball.png": 3699,
	"./Rose Gilded.png": 3102,
	"./Solana.png": 7394,
	"./Standard Issue.png": 5574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5522;